// tslint:disable
export var PrescriptionBenefitType;
(function (PrescriptionBenefitType) {
    // Prescription is paid by medical insurance.
    PrescriptionBenefitType[PrescriptionBenefitType["Medical"] = 1] = "Medical";
    // Prescription is paid by pharmacy benefit manager.
    PrescriptionBenefitType[PrescriptionBenefitType["Pharmacy"] = 2] = "Pharmacy";
})(PrescriptionBenefitType || (PrescriptionBenefitType = {}));
PrescriptionBenefitType['MEDICAL'] = 1;
PrescriptionBenefitType['PHARMACY'] = 2;
//# sourceMappingURL=PrescriptionBenefitType.js.map